<script setup>
import { computed } from 'vue';

const props = defineProps({
  contact: { type: Object, default: () => ({}) },
  size: {
    type: String,
    default: 'sm',
    validator: v => ['xs', 'sm', 'md'].includes(v),
  },
  showLabel: { type: Boolean, default: true },
});

const STATUS_ACCENT = {
  Novo: {
    dot: 'bg-n-slate-9',
    chip: 'bg-n-slate-3 text-n-slate-12 ring-n-slate-6',
  },
  Contatado: {
    dot: 'bg-n-blue-9',
    chip: 'bg-n-blue-3 text-n-blue-12 ring-n-blue-7',
  },
  Qualificado: {
    dot: 'bg-n-teal-9',
    chip: 'bg-n-teal-3 text-n-teal-12 ring-n-teal-7',
  },
  Agendado: {
    dot: 'bg-n-amber-9',
    chip: 'bg-n-amber-3 text-n-amber-12 ring-n-amber-7',
  },
  Confirmado: {
    dot: 'bg-n-grass-9',
    chip: 'bg-n-grass-3 text-n-grass-12 ring-n-grass-7',
  },
  Realizado: {
    dot: 'bg-n-grass-10',
    chip: 'bg-n-grass-4 text-n-grass-12 ring-n-grass-8',
  },
  Faltou: {
    dot: 'bg-n-ruby-9',
    chip: 'bg-n-ruby-3 text-n-ruby-12 ring-n-ruby-7',
  },
  Perdido: {
    dot: 'bg-n-slate-6',
    chip: 'bg-n-alpha-2 text-n-slate-11 ring-n-slate-5',
  },
};

const DEFAULT_ACCENT = {
  dot: 'bg-n-slate-6',
  chip: 'bg-n-alpha-2 text-n-slate-11 ring-n-slate-5',
};

const status = computed(() => props.contact?.custom_attributes?.sdr_status || null);

const accent = computed(() => STATUS_ACCENT[status.value] || DEFAULT_ACCENT);

const sizeClasses = computed(() => {
  const map = {
    xs: { pill: 'px-1.5 py-0 text-[9.5px]', dot: 'size-1.5' },
    sm: { pill: 'px-1.5 py-0.5 text-[10px]', dot: 'size-1.5' },
    md: { pill: 'px-2 py-0.5 text-[11px]', dot: 'size-2' },
  };
  return map[props.size] || map.sm;
});
</script>

<template>
  <span
    v-if="status"
    :class="[
      'inline-flex items-center gap-1 rounded-full ring-1 font-medium leading-none shrink-0',
      sizeClasses.pill,
      accent.chip,
    ]"
    :title="`Status: ${status}`"
  >
    <span
      class="rounded-full shrink-0"
      :class="[sizeClasses.dot, accent.dot]"
      aria-hidden="true"
    />
    <span v-if="showLabel" class="truncate">{{ status }}</span>
  </span>
</template>
